import styled from 'styled-components';

const Icon = styled.svg`
  width: 30px;
  height: 30px;
  vertical-align: bottom;
`;

function Filter() {
  return (
    <Icon version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50" xmlSpace="preserve">
      <g>
        <path d="M25,1C11.767,1,1,11.767,1,25s10.767,24,24,24s24-10.767,24-24S38.233,1,25,1z M25,47C12.869,47,3,37.131,3,25   S12.869,3,25,3s22,9.869,22,22S37.131,47,25,47z" fill="currentColor" />
        <rect height="2" width="24" x="13" y="16" fill="currentColor" />
        <rect height="2" width="18" x="16" y="24" fill="currentColor" />
        <rect height="2" width="12" x="19" y="32" fill="currentColor" />
      </g>
    </Icon>
  );
}

export default Filter;